<template>
  <!-- INFOS -->
  <v-container fluid grid-list-md>
    <v-layout justify-space-between row wrap>
      <v-flex v-for="(item, i) in informations" :key="i" :class="item.class">
        <v-list three-line light class="py-0 elevation-2">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="font-weight-bold">{{item.title}}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{item.subtitle}}</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{item.value | currency}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <!-- INFOS -->
    
    <!-- GRATIFICAÇÃO POSTO DE SERVIÇO -->
    <v-layout justify-start row wrap v-if="serviceStationGratification && serviceStationGratification.length > 0">
      <v-flex xs12>
        <v-divider light></v-divider>
        <v-subheader>Gratificação por Posto de Serviço</v-subheader>
      </v-flex>
      <v-flex v-for="item in serviceStationGratification" :key="item._id" xs12 sm6 md4>
        <v-checkbox :label="item.description"
          return-object :hint="item.value | currency" 
          persistent-hint :value="item" 
          v-model="moduleOne.serviceStationGratification" 
          class="mt-0" :readonly="budgetFinalized"></v-checkbox>
      </v-flex>
    </v-layout>
    <!-- GRATIFICAÇÃO POSTO DE SERVIÇO calculateValueOfServiceStation();-->
    
    <!-- ADICIONAIS PERICULOSIDADE / INSALUBRIDADE -->
    <v-layout justify-start row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
        <v-subheader>Adicionais de Insalubridade e Periculosidade</v-subheader> 
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-currency-field 
          box
          label="Adicional de Insalubridade (em %)"
          v-model="moduleOne.percentOfAdditionalHealth" 
          :hint="additionalHealthValue | currency" 
          persistent-hint :readonly="budgetFinalized"
          v-bind="currency_config_percent">
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-currency-field 
          box
          label="Adicional de Periculosidade (em %)"
          v-model="moduleOne.percentOfAdditionalDanger" 
          :hint="additionalDangerValue | currency" 
          persistent-hint :readonly="budgetFinalized"
          v-bind="currency_config_percent">
        </v-currency-field>
      </v-flex>
    </v-layout>
    <!-- ADICIONAIS PERICULOSIDADE / INSALUBRIDADE -->
    
    <!-- ADICIONAL NOTURNO -->
    <v-layout justify-start row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
        <v-checkbox label="Adicional Noturno" v-model="moduleOne.additionalNocturne.has" @click.native.prevent="checkNocturneAdditional();" :readonly="budgetFinalized"></v-checkbox>
      </v-flex>
      <v-flex xs12 v-if="moduleOne.additionalNocturne.has">
        <v-layout justify-space-between row wrap>
          <v-flex xs12 sm6 md3>
            <v-select v-model="moduleOne.additionalNocturne.workJournie" label="Jornada de Trabalho" :items="worksJournies" item-text="text" item-value="value" :hint="nocturneNormalHourValue | currency({symbol: 'Valor da Hora de Trabalho: R$'})" persistent-hint box class="pr-1" :readonly="budgetFinalized"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-currency-field 
              box
              label="Adicional Noturno (em %)"
              v-model="moduleOne.additionalNocturne.percent"
              :hint="nocturneNormalHourAddPercentHint | currency" 
              persistent-hint :readonly="budgetFinalized"
              v-bind="currency_config_percent">
            </v-currency-field>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-text-field v-model="moduleOne.additionalNocturne.workedHours" type="number" min="0" label="Total de Horas Noturnas Trabalhadas" box class="pr-1" :readonly="budgetFinalized"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-text-field label="Valor do Adicional Noturno (em R$)" :value="nocturneAdditionalValue | currency" box disabled :readonly="budgetFinalized"></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- ADICIONAL NOTURNO -->
    <!-- HORA EXTRA -->
    <v-layout justify-start row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
        <v-checkbox label="Hora Extra" v-model="moduleOne.extraHour.has" @click.native.prevent="checkExtraHours();" :readonly="budgetFinalized"></v-checkbox>
      </v-flex>
      <v-flex xs12 v-if="moduleOne.extraHour.has">
        <v-layout justify-space-between row wrap>
          <v-flex xs12 sm6>
            <v-text-field :value="extraHourValue | currency" label="Valor da Hora Extra (em R$)"  disabled box :readonly="budgetFinalized"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field :value="dsrValue | currency" label="Valor do DSR (em R$)" disabled box :readonly="budgetFinalized"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout justify-space-between row wrap>
          <v-flex xs12 sm4 md2>
            <v-select v-model="moduleOne.extraHour.workJournie" label="Jornada de Trabalho" :items="worksJournies" item-text="text" item-value="value" box :hint="nocturneNormalHourValue | currency({symbol: 'Valor da Hora de Trabalho: R$'})" persistent-hint :readonly="budgetFinalized"></v-select>
          </v-flex>
          <v-flex xs12 sm4 md2>
            <!--valueHours50-->
            <v-text-field v-model="moduleOne.extraHour.hours50" type="number" min="0" label="Horas Trabalhadas com 50%" box :hint="hours50Hint | currency" persistent-hint :readonly="budgetFinalized"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md2>
            <!--valueHours75-->
            <v-text-field v-model="moduleOne.extraHour.hours75" type="number" min="0" label="Horas Trabalhadas com 75%" box :hint="hours75Hint | currency" persistent-hint :readonly="budgetFinalized"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md2>
            <!--valueHours100-->
            <v-text-field v-model="moduleOne.extraHour.hours100" type="number" min="0" label="Horas Trabalhadas com 100%" box :hint="hours100Hint | currency" persistent-hint :readonly="budgetFinalized"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md2>
            <v-text-field v-model="moduleOne.dsr.sundayDays" label="Nº de Domingos / Feriados" type="number" min="0" box :readonly="budgetFinalized"></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md2>
            <v-text-field v-model="moduleOne.dsr.workingDays" label="Nº de Dias Úteis" type="number" min="0" box :readonly="budgetFinalized"></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- HORA EXTRA -->
    <v-layout justify-start row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
      </v-flex>
      <v-flex xs12 sm6>
        <h3>Outros Valores</h3>
      </v-flex>
      <v-flex xs12 sm6>
        <v-btn v-if="!budgetFinalized" block color="primary" title="Adicionar Outro Valor" @click.native.stop.prevent="addBenefit();">
          Adicionar
          <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-layout v-show="moduleOne.others.length > 0" v-for="(item, i) in moduleOne.others" :key="i">
          <v-flex :class="budgetFinalized ? 'xs12' : 'xs11'">
            <v-layout justify-start row wrap>
              <v-flex xs12 sm6>
                <v-text-field label="Descrição" v-model="item.description" box :readonly="budgetFinalized"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-currency-field 
                  box
                  label="Valor" 
                  v-bind="currency_config"
                  v-model="item.value"
                  :readonly="budgetFinalized"
                >
                </v-currency-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs1 v-if="budgetFinalized">
            <v-layout align-center justify-center row fill-height>
              <v-icon class="red--text font-weight-black" title="Remover benefício" @click.stop.prevent="removeBenefit(item);">delete_forever</v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
      </v-flex>
      <v-flex xs12>
        <v-textarea v-model="moduleOne.notes" label="Notas" rows="5" box  :readonly="budgetFinalized"></v-textarea>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  // BIBLIOTECAS //
  import CollectiveConventionService from "../../service/CollectiveConventionService.js";
  import Currency from '../../utils/Currency'
  import ModuleOneService from '../../service/ModuleOneService';
  import SheetDefaultData from '../../data/sheet/SheetDefaultData'
  import {mapState} from "vuex";
  

  export default {
    data() {
      return {
        currency_config: Currency.real,
        currency_config_percent: Currency.percent,
        // ADICIONAL NOTURNO //
        worksJournies: [{
            value: 200,
            text: "200 horas"
          },
          {
            value: 220,
            text: "220 horas"
          }
        ],
        // HORA EXTRA //
        serviceStationGratification: [],
      };
    },
    methods: {
      addBenefit() {
        if(!this.moduleOne.others)
          this.moduleOne.others = new Array()

        this.moduleOne.others.push({
          description: "",
          value: 0,
        });
      },
      checkNocturneAdditional() {
        this.moduleOne.additionalNocturne.has ? false : true;

        if (!this.moduleOne.additionalNocturne.has) {
          // se não tiver adicional noturno zera todas as variáveis possíveis usadas para e como cálculo
          this.moduleOne.additionalNocturne = {has: false, workedHours:0, workJournie: 0, percent:0};
        }
      },
      checkExtraHours() {
        this.moduleOne.extraHour.has ? false : true;

        if (!this.moduleOne.extraHour.has) {
          this.moduleOne.extraHour = {has: false, workJournie: 0, hours50: 0, hours75: 0, hours100: 0}
          this.moduleOne.dsr = {sundayDays: 0, workingDays: 0};
        }
      },
      async getServiceStationGratifications() {
        
        if(!this.sheetHeader.collectiveConvention)
          return []
          
        let convention = await CollectiveConventionService.getById(this.sheetHeader.collectiveConvention);
        this.serviceStationGratification = convention ? convention.serviceStations : []
        
      }, // getServiceStationGratifications() //
      removeBenefit(item) {
        this.moduleOne.others.splice(this.moduleOne.others.indexOf(item), 1);
      },
      async setSheetModuleOne() {
        let sheet = this.$store.getters.getAnalyticalWorksheet
        if(sheet.moduleOne != this.moduleOne){
          sheet.moduleOne = Object.assign({}, this.moduleOne)
          await this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);
        }
      }, // setSheetModuleOne() //
    },

    computed: {
      additionalDangerValue() {
        // sobre Salário Base CCT
        return ModuleOneService.getAdditionalDanger(this.sheetHeader.professionalCategory.basicSalary, this.moduleOne)
      },
      additionalHealthValue() {
        // sobre Salário Mínimo
        return ModuleOneService.getAdditionalHealth(this.sheetHeader.minimalSalary, this.moduleOne)
      },
      dsrValue() {
        return ModuleOneService.getDSR(this.extraHourValue, this.moduleOne.dsr, this.moduleOne.extraHour.has)
      },
      extraHourValue() {
        return ModuleOneService.getExtraHour(this.remunarationBaseValue, this.serviceStationGratificationValue, this.moduleOne.extraHour)
      },
      functionGratificationValue() {
        return ModuleOneService.getFunctionGratification(this.sheetHeader.professionalCategory)
      },
      hours100Hint() {
        return this.normalHour * 2.00 * this.moduleOne.extraHour.hours100
      },
      hours50Hint() {
        return this.normalHour * 1.5 * this.moduleOne.extraHour.hours50
      },
      hours75Hint() {
        return this.normalHour * 1.75 * this.moduleOne.extraHour.hours75
      },
      informations(){
        return [
          {
            class: "xs12 sm6 md3",
            title: "Salário Mínimo",
            subtitle: "De acordo com a CCT cadastrada",
            value: this.sheetHeader.minimalSalary
          },
          {
            class: "xs12 sm6 md3",
            title: "Salário da Convenção Coletiva",
            subtitle: "De acordo com a CCT Cadastrada",
            value: this.sheetHeader.professionalCategory.basicSalary
          },
          {
            class: "xs12 sm6 md3",
            title: "Gratificação de Função",
            subtitle: "De acordo com a CCT Cadastrada",
            value: this.functionGratificationValue
          },
          {
            class: "xs12 sm6 md3",
            title: "Gratificação por Posto de Serviço",
            subtitle: "De acordo com a Seleção abaixo",
            value: this.serviceStationGratificationValue
          },
          {
            class: "xs12",
            title: "Total da Remuneração",
            subtitle: "Soma dos itens",
            value: this.remunerationValue
          },
        ]
      },
      moduleOne() {
        this.getServiceStationGratifications()
        if(this.analyticalWorksheet.moduleOne)
          return this.analyticalWorksheet.moduleOne
       
        return SheetDefaultData.getModuleOne()
      },
      nocturneAdditionalValue(){
        return ModuleOneService.getNocturneAdditional(this.remunarationBaseValue, this.moduleOne.additionalNocturne)
      },
      nocturneNormalHourAddPercentHint() {
        return this.nocturneNormalHourValue + ((this.nocturneNormalHourValue * this.moduleOne.additionalNocturne.percent) / 100)
      },
      nocturneNormalHourValue(){
        return ModuleOneService.getNocturneNormalHour(this.remunarationBaseValue, this.moduleOne.additionalNocturne)
      },
      normalHour() {
        return ModuleOneService.getNormalHour(this.remunarationBaseValue, this.serviceStationGratificationValue, this.moduleOne.extraHour)
      },
      othersValue(){
        return ModuleOneService.getOthers(this.moduleOne.others)
      },
      remunarationBaseValue() {
        return ModuleOneService.getRemunerationBase(this.sheetHeader)
      },
      remunerationValue() {
        let amount = ModuleOneService.getAmountOfModuleOne(this.sheetHeader, this.moduleOne)
        this.$store.commit("SET_AMOUNT_OF_MODULE_ONE", amount);
        return amount;
      },
      serviceStationGratificationValue() {
        return ModuleOneService.getServiceStationGratification(this.moduleOne.serviceStationGratification)
      },
      sheetHeader(){
        return this.analyticalWorksheet.header
      },
      ...mapState({analyticalWorksheet: state => state.budget.analyticalWorksheet}),
      ...mapState({amountOfModuleOne: state => state.budget.amountOfModuleOne}),
      ...mapState({budgetFinalized: state => state.budget.budgetFinalized})
    },
   watch: {
      moduleOne: {
        handler: function(newValue, oldValue) {
          this.setSheetModuleOne()
        },
        deep: true
      }
    }
  };

</script>


// WEBPACK FOOTER //
// src/components/budget/TabModule1.vue